module.exports = __webpack_public_path__ + "static/media/GraphBlack.7f370124.svg";